/**
 * Ryan O'Dowd
 * 2024-03-03
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors, isDarkMode}) => {
  return {
    dragIconWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'grab',
    },
    dragIcon: {
      color: colors.dialogText,
    },
    accordionWrapper: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: 8,
    },
    topRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: 8,
    },
    assignmentName: {
      margin: 0,
      padding: 0,
      color: colors.dialogText, // @TODO: primaryDark on light background
      fontSize: globalScale * 18,
    },
    typeIcon: {
      marginRight: 8,
      fontSize: 24,
      color: colors.primary,
    },
    editRow: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
    fullTitleWrapper: {
      display: 'flex',
      flexDirection: 'column',
    },
    subTitle: {
      color: isDarkMode ? colors.accent : colors.accentDark,
      fontSize: globalScale * 12,
    },
    actionsWrapper: { // @TODO: abstract with module styles
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 8,
    },
    progressWrapper: {
      width: 100, // @TODO: dynamic
      marginRight: 16,
      paddingTop: 12, // to increase click target area
      paddingBottom: 12, // to increase click target area
    },
  };
};

export default getStyles;
